$(document).ready(function(){
   $('.drawer__close button').on('click', function(){
    $('.mm__sublist').removeClass('first-level-open');
     $('.mm__sublist').removeClass('second-level-open');
     $('.mm__nav .mm__sublist').removeClass('child-open');
    $('.drawer__scrollable').removeClass('opened'); 
     $('.mm-wrapper').removeClass('inner-active'); 
  }) 
  $('.mm__nav button').on('click', function(){
    $(this).next('.mm__sublist').addClass('first-level-open');
    $('.mm-extra').addClass('hide');
    $('.drawer__scrollable').addClass('opened'); 
    $('.mm-wrapper').addClass('inner-active'); 
  })
  $('.mm__nav .mm__sublist button').on('click', function(){
    $('.first-level-open').addClass('child-open');
    $(this).parent('.mm__child-item').next('.mm__sublist').addClass('second-level-open');
    $('.mm-extra').addClass('hide');
  }) 

  $('.mm__nav .mm__sublist .first-level-btn').on('click', function(){
     $('.mm__nav .mm__sublist').removeClass('child-open');
    $('.mm__sublist').removeClass('first-level-open');
    $('.mm-extra').removeClass('hide');
    $('.mm-wrapper').removeClass('inner-active'); 
  })
  $('.mm__nav .mm__sublist .second-level-btn').on('click', function(){
    $('.mm__nav .mm__sublist').removeClass('child-open');
    $('.mm__sublist').removeClass('second-level-open');
  })


  
  // Fancybox Config
  $('[data-fancybox="gallery"]').fancybox({
    buttons: [
      "fullScreen",
      "close"
    ],
    arrows: true,
    infobar: false,
    loop: true,
    protect: true,
    backFocus:false,
    hash : false,
    Carousel: {
      Navigation:false
    }
  });
  
  //matchheight
    $('.product_grid__item').matchHeight();
  	$('.grid-product__title').matchHeight();
    
//    $('.product_grid__item .article__grid-meta .article__title.grid__title').matchHeight();

  // Custom sort filter on collection  
  $('[name="custom-filter"]').on('change', function(){
  	location.href = $(this).val();
  });

$('.text-columns.index-section .grid .grid__item .blktxt .title').matchHeight();
$('.text-columns.index-section .grid .grid__item .blktxt .rte-setting').matchHeight();

  
});

// new theme.Slideshow(document.querySelector(".js-logo-slider"),{
//   cellAlign: 'left',
//   contain: true,
//   wrapAround: true,
// adaptiveHeight: true
// })

// Custom scrollbar on featured collection section
$(window).on('load resize', function(){
  if (window.innerWidth <= 768){
    // setTimeout(function(){
    //   $('.featured_collection .grid-overflow-wrapper .grid.grid--uniform').mCustomScrollbar({
    //     axis:"x",
    //     theme:"dark",
    //     advanced:{
    //       autoExpandHorizontalScroll:true
    //    }
    //   });

    //   $('product-recommendations .product_grid__item').matchHeight();
    // }, 3000); 

    // setTimeout(function(){  
    //   $('.product-recommendations .grid-product__title').matchHeight();
    // }, 5000); 
    
    //  $('.logo_section .logo-wrapper .logo-grid').mCustomScrollbar({
    //   axis:"x",
    //   theme:"light-3",
    //   advanced:{
    //     autoExpandHorizontalScroll:true
    //   }
    // });
  }
  
});

function bundleCart(textLength){
	if(textLength > 0){
      $('.gs__builder-total-section button').addClass('active-addtocart');
	  $('#gsMobileNavigation button.removed-active').addClass('active-addtocart');
      $('#gsMobileNavigation button.removed-active').addClass('Polaris-Button--primary');
      $('#gsMobileNavigation button.removed-active').removeClass('removed-active');
    }else{
      $('.gs__builder-total-section button').removeClass('active-addtocart');
      $('#gsMobileNavigation button.Polaris-Button--primary').addClass('removed-active');
	  $('#gsMobileNavigation button.Polaris-Button--primary').removeClass('active-addtocart');
      $('#gsMobileNavigation button.Polaris-Button--primary').removeClass('Polaris-Button--primary');
      
    }		
}

$(document).ready(function(){
  setTimeout(function(){
    if($('#gsBuilderStep textarea').length > 0) {
      var defaultLength = $('#gsBuilderStep textarea').val().length;
      bundleCart(defaultLength);
    }
    if($('[aria-label="picture of undefined"]').length > 0){
      bundleCart(1);
    }
  }, 2000);  
});

// $(document).on('keyup', '#gsBuilderStep textarea', function(ev){
//   var textLength = $(this).val().length;
//   bundleCart(textLength);
// });

$(document).on('click', '#gsBuilderStep button', function(e){
  if($('#gsBuilderStep textarea').length > 0){
    var defaultLength = $('#gsBuilderStep textarea').val().length;
    
    setTimeout(function(){
    	bundleCart(defaultLength);
    }, 500);
  }
});

$(document).on('click', '#gsMobileNavigation button', function(e){
   setTimeout(function(){
    if($('#gsBuilderStep textarea').length > 0) {
      var defaultLength = $('#gsBuilderStep textarea').val().length;
      bundleCart(defaultLength);
    }
  }, 2000); 
});



// let heroSwiper = document.querySelectorAll(".slideshowSwiper");

// heroSwiper.forEach(slider  => {
//   var s_swiper = new Swiper(slider,options = {
//     loop: true,
//     // autoplay: {
//     //   delay: 2500,
//     //   disableOnInteraction: false,
//     // },
//    autoplay: false,
//    navigation: (slider.dataset.arrows == "true") ? {
//       nextEl: `#section--${slider.dataset.sectionId} .swiper-button-next`,
//       prevEl: `#section--${slider.dataset.sectionId} .swiper-button-prev`,
//     } : false,
//     breakpoints: {
//       320: {
//         autoHeight: false
//       },
//       769: {
//         autoHeight: false
//       }
//     }
//   });
// })

$('.hero__text-wrap').matchHeight();



//scroll to after pagination for gallery page
function scrollToTop() {
  window.scrollTo({
    top: document.querySelector('.paginated-blocks-wrapper').offsetTop,
    behavior: 'auto'
  });
}

if(document.querySelector('.paginated-blocks-wrapper')){
  
  let swiperPaginationGallery = document.querySelector('.swiper-pagination'),
      swiperButton = document.querySelectorAll('.pagination-footer .swiper-arrows'),
      getScrollValue = document.querySelector('.paginated-blocks-wrapper').getAttribute("data-scroll-value");
  
  if(getScrollValue == 'true') { 
     swiperPaginationGallery.addEventListener('click', () => {
        scrollToTop();
      });
    
      swiperButton.forEach(function(ele){
        ele.addEventListener('click', () => {
          scrollToTop();
        });
      });
  }
}